
export enum WarningLevel {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  OVERDUE = 'OVERDUE',
}
